// extracted by mini-css-extract-plugin
export default {"card":"Card_card__ER1p2","card-document":"Card_card-document__rAQHk"};